const alpha_numerical_input = {
    methods: {
        autoselect_action (event) {
            if(this.autoselect_on_focus) event.target.select()
        },
        touchstart () {
            if(this.alphaNumeric && this.iOS) this.touching = true
        },
        keydown () {
            if(this.alphaNumeric && this.iOS) this.touching = false
        },
        blur () {
            if(this.alphaNumeric && this.iOS) this.touching = false
        }
    },
    computed: {
        iOS () {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        },
        autoselect_on_focus () {
            return true
        },
        live_type () {
            if(this.alphaNumeric && this.iOS) return "number"
            return this.type
        }
    },
    props: {
        alphaNumeric: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            touching: false
        }
    }
}

export default alpha_numerical_input
